export const YellowCancel = (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
        <path
            fill="#FFD43B"
            fillRule="evenodd"
            d="M3.68 5.094A8 8 0 0 0 14.905 16.32L3.68 5.094ZM5.094 3.68 16.32 14.906A8 8 0 0 0 5.094 3.68ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Z"
            clipRule="evenodd"
        />
    </svg>
);
